import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BNavItem } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router/composables";
import { useNotificationsStore } from "@/stores/notificationsStore";
import Popper from "components/Popper/Popper.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsBell',
    props: {
        tooltipPlacement: {
            type: String,
            default: "right",
        },
    },
    setup(__props) {
        library.add(faBell);
        const router = useRouter();
        const { totalUnreadCount } = storeToRefs(useNotificationsStore());
        function onClick() {
            router.push("/user/notifications");
        }
        return { __sfc: true, router, totalUnreadCount, onClick, faBell, FontAwesomeIcon, BNavItem, Popper };
    }
});
